import { formatTime, MS_PER_MINUTE, shortDate } from './dates.js';
import { expandEvent } from './occurrences.js';
/** Largest offset we ever have to look ahead for: the schema caps reminders at 30 days. */
const MAX_LOOKAHEAD_MS = 60 * 24 * 30 * MS_PER_MINUTE;
export function remindersDueBetween(events, window) {
    if (window.until <= window.after)
        return [];
    const due = [];
    for (const event of events) {
        if (event.reminders.length === 0)
            continue;
        // Occurrences that could possibly own a reminder firing in the window.
        const occurrences = expandEvent(event, {
            from: window.after,
            to: window.until + MAX_LOOKAHEAD_MS,
            limitPerEvent: 200,
        });
        for (const occurrence of occurrences) {
            const startMs = Date.parse(occurrence.start);
            for (const reminder of event.reminders.slice(0, 3)) {
                const fireAt = startMs - reminder.minutesBefore * MS_PER_MINUTE;
                if (fireAt <= window.after || fireAt > window.until)
                    continue;
                due.push({
                    eventId: event.id,
                    title: event.title,
                    occurrenceStart: occurrence.start,
                    minutesBefore: reminder.minutesBefore,
                    fireAt: new Date(fireAt).toISOString(),
                    ownerIds: [...event.ownerIds],
                    ...(event.location ? { location: event.location } : {}),
                    key: `${event.id}@${occurrence.start}#${reminder.minutesBefore}`,
                });
            }
        }
    }
    return due.sort((a, b) => Date.parse(a.fireAt) - Date.parse(b.fireAt));
}
/** "in 30 minutes" / "at 4:00p" / "tomorrow" — the body of a reminder push. */
export function describeLeadTime(minutesBefore) {
    if (minutesBefore === 0)
        return 'starting now';
    if (minutesBefore < 60)
        return `in ${minutesBefore} minutes`;
    if (minutesBefore < 60 * 24) {
        const hours = Math.round(minutesBefore / 60);
        return `in ${hours} hour${hours === 1 ? '' : 's'}`;
    }
    const days = Math.round(minutesBefore / (60 * 24));
    return days === 1 ? 'tomorrow' : `in ${days} days`;
}
/** Push copy for a due reminder: "Soccer — in 30 minutes (Thu 4:00p)". */
export function reminderPushBody(reminder, now = new Date()) {
    const start = new Date(reminder.occurrenceStart);
    const when = `${shortDate(start, now)} ${formatTime(start)}`;
    const lead = describeLeadTime(reminder.minutesBefore);
    return reminder.location ? `${lead} · ${when} · ${reminder.location}` : `${lead} · ${when}`;
}
//# sourceMappingURL=reminders.js.map